export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./lk-course-info.vue?vue&type=template&id=7060a41c&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-course/lk-course-info/lk-course-info.vue?vue&type=template&id=7060a41c&
// module id = 1500
// module chunks = 0